import { useCallback, useState } from 'react';
import { getRecent, RecentItem } from './recentItems';
import { useStorageSync } from './useStorageSync';

/**
 * Live list of recently-viewed claim/tow-request entries. Re-evaluates on
 * `itow-recents-changed` (in-page) and `storage` (cross-tab) events.
 */
export function useRecentItems(): RecentItem[] {
  const [items, setItems] = useState<RecentItem[]>(() => getRecent());
  const update = useCallback(() => setItems(getRecent()), []);
  useStorageSync('itow-recents-changed', update);
  return items;
}
